var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"d-flex flex-column justify-center",attrs:{"padless":""}},[_c('strong',[_vm._v(_vm._s(_vm.siteName))])])}
var staticRenderFns = []

export { render, staticRenderFns }